import React from "react";
import {
  Area,
  AreaChart,
  CartesianGrid,
  Pie,
  PieChart,
  XAxis,
  YAxis,
} from "recharts";
import Header from "../components/common-web/Header";
import Navbar from "../components/common-web/Navbar";
import BottomAreaTable from "../components/dashboard/left-area/BottomTable";
import DashboardImage from "../components/dashboard/left-area/DashboardImage";
import DashboardSection from "../components/dashboard/left-area/DashboardSection";
import SiteInfo from "../components/dashboard/left-area/SiteInfo";
import TopAreaTable from "../components/dashboard/left-area/TopAreaTable";
import TotalCapacity from "../components/dashboard/left-area/TotalCapacity";

const data = [
  { name: "1", uv: 0 },
  { name: "2", uv: 0 },
  { name: "3", uv: 0 },
  { name: "4", uv: 0 },
  { name: "5", uv: 0 },
  { name: "6", uv: 0 },
  { name: "7", uv: 0 },
  { name: "8", uv: 0 },
  { name: "9", uv: 0 },
  { name: "10", uv: 20 },
  { name: "11", uv: 30 },
  { name: "12", uv: 40 },
  { name: "13", uv: 60 },
  { name: "14", uv: 70 },
  { name: "15", uv: 80 },
  { name: "16", uv: 80 },
  { name: "17", uv: 81 },
  { name: "18", uv: 82 },
  { name: "19", uv: 83 },
  { name: "20", uv: 81 },
  { name: "21", uv: 85 },
  { name: "22", uv: 30 },
  { name: "23", uv: 10 },
  { name: "24", uv: 0 },
];

export default function Dashboard() {
  return (
    <main className="bg-[#262d44] xl:h-screen flex flex-col overflow-hidden">
      <Header>
        <Navbar path="/dashboard" />
      </Header>

      <div className="flex-1 flex flex-col gap-2.5 overflow-y-auto custom-scrollbar p-2.5 bg-[#F0F0F0]">
        {/* top section start from here  */}
        <div className="flex flex-col xl:flex-row gap-2.5">
          {/* left section start from here  */}
          <aside className="w-full xl:max-w-[372px] flex-shrink-0 flex flex-col gap-2.5">
            <DashboardImage />
            <SiteInfo />
            <TotalCapacity />
          </aside>
          {/* right section start from here  */}
          <div className="w-full flex-grow overflow-hidden flex flex-col gap-2.5">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-2.5 xl:h-[271px]">
              {[
                {
                  label: "frequency",
                  color: "#DEF0FC",
                  value: "49.66",
                  unit: "Hz",
                  haveLimit: false,
                  data: [
                    { value: 49.66, fill: "#DEF0FC" },
                    { value: 50.34, fill: "#D9D9D9" },
                  ],
                },
                {
                  label: "ambient temperature",
                  color: "#138A98",
                  value: "33.07",
                  unit: "°C",
                  haveLimit: false,
                  data: [
                    { value: 33.07, fill: "#138A98" },
                    { value: 66.93, fill: "#D9D9D9" },
                  ],
                },
                {
                  label: "relative humidity",
                  color: "#00497C",
                  value: "50.14",
                  unit: "%",
                  haveLimit: true,
                  data: [
                    { value: 50.14, fill: "#00497C" },
                    { value: 49.86, fill: "#D9D9D9" },
                  ],
                },
              ].map((item, index) => (
                <React.Fragment key={index}>
                  <div
                    key={index}
                    className="bg-white p-5 flex flex-col justify-between items-center"
                  >
                    <div className="flex items-center gap-2.5">
                      <div
                        className="size-3.5 flex-shrink-0"
                        style={{ backgroundColor: item.color }}
                      ></div>
                      <h5 className="text-xs font-bold text-[#242424] capitalize">
                        {item.label}
                      </h5>
                    </div>
                    <div className="w-full max-w-[260px] flex justify-center items-center relative mb-4">
                      <PieChart
                        width={260}
                        height={130}
                        style={{ margin: "0 auto" }}
                      >
                        <Pie
                          dataKey="value"
                          startAngle={180}
                          endAngle={0}
                          data={item.data}
                          cx={"50%"}
                          cy={"100%"}
                          innerRadius={65}
                          outerRadius={100}
                          fill="#D9D9D9"
                          stroke="none"
                          isAnimationActive={true}
                          className="z-0"
                        />
                      </PieChart>

                      <div className="absolute bottom-0  left-1/2 transform -translate-x-1/2">
                        <p className="text-xl font-bold text-[#242424]">
                          {item.value}
                          {item.unit}
                        </p>
                      </div>
                      {item.haveLimit && (
                        <>
                          <span className="absolute -bottom-4 left-[35px] font-semibold text-[#242424] w-6 flex items-center justify-center text-sm">
                            0
                          </span>

                          {/* ✅ Max Label */}
                          <span className="absolute -bottom-4 right-[35px] font-semibold text-[#242424] w-6 flex items-center justify-center text-sm">
                            100
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </React.Fragment>
              ))}
            </div>

            {/* // table area start from here  */}
            <TopAreaTable />
          </div>
          {/* right section start from here  */}
          <aside className="w-full xl:max-w-[555px] flex-shrink-0 flex flex-col items-stretch gap-2.5">
            <DashboardSection title="Greenhouse Gas Emissions">
              <AreaChart
                style={{
                  width: "100%",
                  // maxWidth: "522px",
                  maxHeight: "230px",
                  aspectRatio: 1.618,
                }}
                responsive
                data={data}
                margin={{
                  top: 20,
                  right: 0,
                  left: 0,
                  bottom: 0,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis width="auto" />
                <Area
                  type="monotone"
                  dataKey="uv"
                  stroke="#23487e"
                  fill="#DEF0FC"
                  dot={{
                    r: 4, // radius of dot
                    stroke: "#23487e", // border color
                    strokeWidth: 2,
                    fill: "transparent", // transparent inside
                  }}
                  activeDot={{
                    r: 6, // slightly bigger when hovered
                    stroke: "#23487e",
                    strokeWidth: 2,
                    fill: "transparent",
                  }}
                />
              </AreaChart>
            </DashboardSection>
            <DashboardSection title="Greenhouse Gas Emissions intensity">
              <AreaChart
                style={{
                  width: "100%",
                  // maxWidth: "522px",
                  maxHeight: "230px",
                  aspectRatio: 1.618,
                }}
                responsive
                data={data}
                margin={{
                  top: 20,
                  right: 0,
                  left: 0,
                  bottom: 0,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis width="auto" />
                <Area
                  type="monotone"
                  dataKey="uv"
                  stroke="#23487e"
                  fill="#DEF0FC"
                  dot={{
                    r: 4, // radius of dot
                    stroke: "#23487e", // border color
                    strokeWidth: 2,
                    fill: "transparent", // transparent inside
                  }}
                  activeDot={{
                    r: 6, // slightly bigger when hovered
                    stroke: "#23487e",
                    strokeWidth: 2,
                    fill: "transparent",
                  }}
                />
              </AreaChart>
            </DashboardSection>
          </aside>
        </div>
        <BottomAreaTable />
      </div>
    </main>
  );
}
